import * as faceapi from 'face-api.js';

let loadPromise: Promise<void> | null = null;
let isLoaded = false;

// Приложение раздаётся из подпапки (PUBLIC_URL: `/ravelo` на проде,
// `/ravelo-stage` на стейдже, '' в локальной разработке), поэтому веса
// tiny_face_detector лежат не в корне, а в `<PUBLIC_URL>/models`.
export const FACE_API_MODELS_URL = `${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/models`;

export const loadFaceApiModels = async (): Promise<void> => {
  // Если уже загружено - возвращаем сразу
  if (isLoaded) {
    return Promise.resolve();
  }

  // Если уже загружается - возвращаем существующий promise
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = (async () => {
    try {
      // Загружаем модели
      await faceapi.nets.tinyFaceDetector.loadFromUri(FACE_API_MODELS_URL);

      // Pre-warm WASM/GPU с фиктивной детекцией
      try {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = 224;
        tempCanvas.height = 224;
        await faceapi.detectSingleFace(
          tempCanvas as any,
          new faceapi.TinyFaceDetectorOptions({ inputSize: 224 })
        );
      } catch {
        // Игнорируем ошибки pre-warming
      }

      isLoaded = true;
    } catch (error) {
      console.error('Failed to load face-api models:', error);
      isLoaded = true;
    } finally {
      loadPromise = null;
    }
  })();

  return loadPromise;
};
